import React from 'react';

const GooglePlayIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={`sw-google-play-icon${className ? ` ${className}` : ''}`}
    focusable="false"
    viewBox="0 0 32 32"
  >
    <path d="M5.4 3.7c-.4.4-.6 1-.6 1.8v21c0 .8.2 1.4.7 1.8l11.8-12.4L5.4 3.7Z" fill="#34a853" />
    <path d="m21.6 11.4-4.3 4.5 4.4 4.6 5.4-3.1c1.6-.9 1.6-2.4 0-3.3l-5.5-2.7Z" fill="#fbbc04" />
    <path d="m5.5 3.6 11.8 12.3 4.3-4.5L8.6 4c-1.2-.7-2.3-.8-3.1-.4Z" fill="#4285f4" />
    <path d="M5.5 28.3c.8.4 1.9.3 3.1-.4l13.1-7.4-4.4-4.6L5.5 28.3Z" fill="#ea4335" />
  </svg>
);

export default GooglePlayIcon;
